var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.791 4.209c-.278-.279-.718-.279-.974 0L12 11.026 5.183 4.21c-.279-.279-.72-.279-.974 0-.279.278-.279.719 0 .974L11.026 12 4.21 18.817c-.279.279-.279.72 0 .974.139.14.324.209.487.209s.347-.07.487-.209L12 12.974l6.817 6.817c.14.14.325.209.487.209.163 0 .348-.07.487-.209.279-.278.279-.718 0-.974L12.974 12l6.817-6.817a.67.67 0 0 0 0-.974",
  clipRule: "evenodd"
})));
export { SvgClose as ReactComponent };